import React from 'react';
import { GeneralFila } from '../../../Models/General';
import FilaNota from './FilaNota';
import { Link } from 'react-router-dom';
import { conNota } from '../../../Models/Ventas';
import CardBuscador from '../../../Utiles/Buscadores/Card';
import { Producto } from '../../../Models/Productos';
import Avanzado, { AvanzadosProps } from '../../../Utiles/Componentes/Avanzado';
import { NotasContext } from '../../../Context/Ventas/Notas';
import NotaExcel from './Excel';
import { Col } from 'react-bootstrap';
class ListNotas extends CardBuscador {
    con = conNota();
    placeholder = "BUSCAR NOTA DE ENTREGA";
    buscarEn = ["codigo", "nombre", 'fecha', 'rif'];
    fecha_init = 'dd/mm/aaaa';
    fecha_fin = 'dd/mm/aaaa';
    productos: Producto[] = []
    status = -1;
    user = -1;
    Avansado() {
        const { fecha_init, fecha_fin, status, user, productos, setAvanzados } = this;
        return <Avanzado setData={setAvanzados.bind(this)}
            estatus={['CANCELADO', 'ENTREGADA', 'FACTURADA']}
            fecha_init={fecha_init} fecha_fin={fecha_fin}
            status={status} user={user} productos={productos} />
    }
    setAvanzados({ fecha_init, fecha_fin, status, user, productos }: AvanzadosProps) {
        if (fecha_init) this.fecha_init = fecha_init;
        if (fecha_fin) this.fecha_fin = fecha_fin;
        if (user) this.user = user;
        if (status) this.status = status;
        if (status === 0) this.status = status;
        if (productos) this.productos = productos;
        this.forceUpdate()
    }
    filter() {
        const { fecha_init, fecha_fin, status, user, productos, datetonomber } = this;
        let itens = this.ordenar();
        return itens.filter((c: GeneralFila) => {
            if (c.status !== status && status !== -1) return false;
            if (c.usuario !== user && user !== -1) return false;
            const creacion = datetonomber(c.fecha);
            if (fecha_fin !== 'dd/mm/aaaa' && creacion > datetonomber(fecha_fin)) return false;
            if (fecha_init !== 'dd/mm/aaaa' && creacion < datetonomber(fecha_init)) return false;
            if (!productos.every(p => c.detalles.some(d => p.codigo === d))) return false;
            return true;
        });
    }
    Title() {
        return <>
            <h4 className='mr-auto'><i className="fa fa-search"></i> BUSCAR NOTA DE ENTREGA</h4>
            <Link to="/nota/nueva" className="btn btn-primary"><span className="fa fa-plus"></span>NUEVA NOTA DE ENTREGA</Link>
        </>
    }
    Header() {
        const { Th } = this;
        return <tr className="info">
            <Th label='codigo' width='100px'>N°</Th>
            <Th label='fecha' width='120px'>FECHA</Th>
            <Th label='nombre' width='calc(100% - 585px)'>CLIENTE</Th>
            <Th width='160px'>MONTO</Th>
            <Th width='100px'>ESTATUS</Th>
            <Th width='135px'>ACCIONES</Th>
        </tr>
    }
    Row(p: GeneralFila) {
        return <FilaNota con={this.con} key={"cot" + p.codigo + p.status} data={p} />
    }
    getItens() { return this.context.Notas; }
    set() { this.context.actNota(); }
    getEstado() { return this.context.estNota; }

    Actualizar() {
        const { hora } = this.getEstado();
        return <Col md={3} className='mr-auto d-flex flex-row-reverse'>
            <NotaExcel nota={this.filter()} />
            <div style={{ fontSize: '12px', width: "200px", paddingLeft: '15px' }}>
                <strong>ACTUALIZADO:</strong> <br />
                {hora}
            </div>
        </Col>
    }
}
ListNotas.contextType = NotasContext;
export default ListNotas
